import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "environments/environment";
import {RelatedProductsProgram, UpdateRelatedProductsProgram} from "app/models/menu.model";
import {firstValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RpProgramsService {
  private requestPath = `${environment.posBaseUrl}/api/front/rp-programs`;
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });
  constructor(
    private http: HttpClient,
  ) { }

  async create(requestDto: UpdateRelatedProductsProgram) : Promise<RelatedProductsProgram> {
    try{
      return await firstValueFrom(
        this.http.post<RelatedProductsProgram>(
          this.requestPath,
          requestDto,
          {
            headers: this.headers,
          }
        )
      );
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async update(rpProgramId: string, requestDto: UpdateRelatedProductsProgram) : Promise<RelatedProductsProgram> {
    try{
      return await firstValueFrom(
        this.http.put<RelatedProductsProgram>(
          this.requestPath + "/" + rpProgramId,
          requestDto,
          {
            headers: this.headers,
          }
        )
      );
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async delete(rpProgramId: string) {
    try {
      return await firstValueFrom(this.http.delete<null>(
        this.requestPath + "/" + rpProgramId,
      ))
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }
}
